import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';

@Injectable()
export class ToastProvider {

  constructor(public http: HttpClient, private toastCtrl: ToastController) {
  }

  presentToast(msg: string, type: ToastType = ToastType.default, duration = 3000) {
    let toast: any;
    let cssClass: string;
    switch(type){
      case ToastType.success:
        cssClass = 'success';
        break;
      case ToastType.danger:
        cssClass = 'danger';
        break;
      case ToastType.primary:
        cssClass = 'primary';
        break;
      default:
        cssClass = 'default';
    }

    toast = this.toastCtrl.create({
      message: msg,
      duration: duration,//3000,
      position: 'bottom',
      cssClass
    });
  
    toast.onDidDismiss(() => {
    });
  
    toast.present();
  }

}

export enum ToastType {
  success,
  danger,
  primary,
  default
}



// WEBPACK FOOTER //
// ./src/providers/toast/toast.ts